<script>
import { v4 as uuidv4 } from "uuid";
import {
    modalState,
    showModal,
    hideModal,
} from "@app/store/modalStore.svelte.js";
import { environment } from "@app/store/envStore.svelte.js";
import { uiState } from "@app/store/uiStore.svelte.js";
import { updateDuration } from "@app/store/playerStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import { projectState } from "@app/store/projectStore.svelte.js";
import {
    eventGroupState,
    resetEventGroupState,
} from "@app/store/eventGroupStore.svelte.js";
import { insertHistoryAction, resetHistory } from "@app/store/historyStore.svelte.js";
import { fade } from "svelte/transition";
import { tick, onDestroy, onMount } from "svelte";
import { BarLoader } from "svelte-loading-spinners";
import * as m from "@app/paraglide/messages.js";
/* Firebase */
import firebase from "@app/configs/firebase.js";

/* CC LIB */
import _Project from "@cclib/classes/project.js";
import _EventGroup from "@cclib/classes/eventGroup.js";
import _Event from "@cclib/classes/event.js";
import tcLib from "@cclib/lib/timecode.js";
import frameRates from "@cclib/dict/frameRates.js";

let shareCode = $state(""),
    syncing = $state(false),
    statusMsg = $state(m.team_project_import_status_pulling_latest_commit()),
    audioExtractionComplete = false,
    manifestFileExists = false,
    audioExtractionWorker = environment.electron
        ? new Worker("./build/workers/audioExtraction.js")
        : null,
    proxyRtWorker = environment.electron
        ? new Worker("./build/workers/proxyRt.js")
        : null,
    audioWaveformPath,
    videoOutputPath,
    audioOutputPath,
    ffmpegRes;

onMount(async () => {
    // console.info("DEBUG: Parsing URL params from URL: " + window.location.href);
    let urlString = window.location.href;
    let url = new URL(urlString);
    shareCode = url.searchParams.get("id") || "";
    // console.info("DEBUG: Share code from URL: " + shareCode);
    if (shareCode) {
        importProject();
    }
});

onDestroy(async () => {
    if (audioExtractionWorker) {
        audioExtractionWorker.terminate();
    }

    if (proxyRtWorker) {
        proxyRtWorker.terminate();
    }
});

async function getFileMetadata(filePath, ffmpegFullPath) {
    try {
        const exec = window.exec;
        return await exec(
            `"${ffmpegFullPath.replace("app.asar", "app.asar.unpacked")}" -y -i "${filePath}"`,
        );
    } catch (err) {
        return err.message;
    }
}

function getMediaIncode(ffmpegOutput) {
    let matches = ffmpegOutput.match(
        /(?<=timecode\s+:\s+)\d\d:\d\d:\d\d(:|;)\d\d/,
    );
    let mediaIncode = matches ? matches[0].replace(";", ":") : false;

    console.log("Media incode detected: " + mediaIncode);
    return mediaIncode == "null" ? false : mediaIncode;
}

function getMediaFrameRate(ffmpegOutput) {
    // console.log("GETTING MEDIA FRAME RATE");
    //console.log("FFMPEG OUTPUT:");
    //console.log(ffmpegOutput);

    let matches = ffmpegOutput.match(/\d+\.\d+(?= fps)|\d+(?= fps)/);
    let mediaFrameRate = matches ? matches[0] : false;

    console.log("Media frame rate detected: " + mediaFrameRate);
    let fr = frameRates.frameRateMapping[mediaFrameRate];
    return fr;
}

function getMediaDuration(ffmpegOutput) {
    /*  console.log("GETTING MEDIA DURATION");
        console.log("FFMPEG OUTPUT:");
        console.log(ffmpegOutput); */
    let matches = ffmpegOutput.match(/(?<=Duration:\s)\d\d:\d\d:\d\d\.\d\d/);
    let mediaDuration = matches ? matches[0] : false;

    console.log(mediaDuration);
    if (mediaDuration) {
        mediaDuration = tcLib.tcMsToSec(mediaDuration);
        console.log("media duration in seconds: " + mediaDuration);
    }

    return mediaDuration;
}

function checkFileExistsSync(filePath) {
    try {
        fsSync.accessSync(filePath);
        return true;
    } catch (error) {
        return false;
    }
}

async function importProject() {
    /* rkeMvkZOeDPNZrlyjdEIrJeEs0P2-06e590bf-22ce-4902-9bbf-d0e100dd2208 */
    toast.push(m.team_project_import_starting_info(), {
        classes: ["toast-info"],
    });

    try {
        if (!shareCode) {
            throw new Error(m.team_project_import_share_code_required());
        }

        syncing = true;
        let commitFileUrl = await firebase
            .functions()
            .httpsCallable("v8ImportTeamProjectV2")(shareCode.trim());
        console.log(commitFileUrl);
        let commitFileRes = await fetch(commitFileUrl.data[0]);
        let commitFileJson = await commitFileRes.json();
        console.log("COMMIT FILE JSON:", commitFileJson);

        statusMsg = m.team_project_import_status_loading_commit();

        /* Clear and wait for update... */
        projectState.selected = false;
        await tick();
        resetEventGroupState();
        await tick();

        projectState.commit = commitFileJson.id;
        projectState.ownerId = commitFileJson.ownerId;
        projectState.type = "team";
        projectState.teamId = commitFileJson.teamId;
        projectState.name = commitFileJson.name || m.team_project_import_untitled_name();
        projectState.frameRate = parseFloat(commitFileJson.frameRate);
        projectState.dropFrame = parseFloat(commitFileJson.dropFrame);
        projectState.username = firebase.auth().currentUser.email;
        projectState.media = commitFileJson.media;

        commitFileJson.eventGroups.forEach((eventGroup) => {
            if (eventGroup.state !== "deleted") {
                let teamEvGroup = {
                    ...new _EventGroup({
                        ...eventGroup,
                        events: [],
                    }),
                };

                teamEvGroup.id = eventGroup.id;

                eventGroup.events.forEach((event) => {
                    if (event.state !== "deleted") {
                        let teamEv = { ...new _Event(event) };
                        teamEv.id = event.id;
                        teamEvGroup.events.push(teamEv);
                    }
                });

                eventGroupState.push(teamEvGroup);
            }
        });

        if (eventGroupState.length > 0) {
            projectState.selected = 0;
        }

        resetHistory();
        insertHistoryAction({
            name: "import project", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                },
            ],
        });

        statusMsg = m.team_project_import_status_done();
        toast.push(m.team_project_import_complete(), {
            classes: ["toast-success"],
        });

        if (
            ((commitFileJson.media.storage === "Local Storage" ||
                commitFileJson.media.storage === "Proxy RT") &&
                !environment.electron) ||
            commitFileJson.media.localPath === ""
        ) {
            player.src = '';
            showModal("mediaImport");
        } else {
            importMedia();
        }
    } catch (err) {
        console.log(err, err.message);
        toast.push(m.team_project_import_failed({ message: err.message }), {
            classes: ["toast-danger"],
        });
        hideModal();
    }
}

async function importMedia() {
    try {
        updateDuration(false);
        uiState.timeline = false;
        player.src = '';
        let mediaType = "video/mp4";
        switch (projectState.media.storage) {
            case "Vimeo":
                player.src = projectState.media.path;
                manifestFileExists = true;
                audioExtractionComplete = true;
                projectState.media.useFallback = true;
                break;
            case "YouTube":
                player.src = projectState.media.path;
                manifestFileExists = true;
                audioExtractionComplete = true;

                projectState.media.useFallback = true;
                break;
            case "HLS Manifest":
                audioExtractionComplete = true;
                player.src = projectState.media.path;
                projectState.media.useFallback = true;
                break;
            case "Proxy RT":
                if (!checkFileExistsSync(projectState.media.localPath)) {
                    toast.push(
                        m.team_project_import_media_not_found(),
                        { classes: ["toast-danger"] },
                    );
                    showModal("mediaImport");
                    return;
                }

                videoOutputPath = os.tmpdir() + path.sep + uid + ".mp4";
                audioOutputPath = os.tmpdir() + path.sep + uid + ".json";
                projectState.media.path = videoOutputPath;

                ffmpegRes = await getFileMetadata(
                    projectState.media.localPath,
                    window.ffmpegPath
                );
                projectState.media.info = {
                    incode: getMediaIncode(ffmpegRes),
                    frameRate: getMediaFrameRate(ffmpegRes),
                    duration: getMediaDuration(ffmpegRes),
                };

                audioExtractionWorker.postMessage({
                    inputPath: projectState.media.localPath,
                    outputPath: audioOutputPath,
                    ffmpegPath: window.ffmpegPath,
                    duration: projectState.media.info.duration,
                });

                audioExtractionWorker.onmessage = (msg) => {
                    // console.log(msg);
                    if (msg.data.status === "in_progress") {
                        console.log(msg.data.result);
                    } else {
                        projectState.media.peaksPath = msg.data.error
                            ? ""
                            : audioOutputPath;
                        projectState.media.useFallback = false;

                        toast.push(
                            `${msg.data.error ? msg.data.error : m.team_project_import_audio_extraction_complete()}`,
                            {
                                classes: [
                                    `toast-${msg.data.error ? "danger" : "success"}`,
                                ],
                            },
                        );

                        audioExtractionComplete = true;
                        closeModal();
                    }
                };
                
                proxyRtWorker.postMessage({
                    inputPath: projectState.media.localPath,
                    outputPath: videoOutputPath,
                    ffmpegPath: window.ffmpegPath,
                    tmpDir: os.tmpdir(),
                    pathSep: path.sep,
                });

                proxyRtWorker.onmessage = async (msg) => {
                    //console.log(msg);
                    if (msg.data.status === "in_progress") {
                        statusMsg = msg.data.status_msg;
                        mediaProgress = m.team_project_import_media_progress_in_progress();
                    } else if (
                        msg.data.status === "done" &&
                        msg.data.result === "passed"
                    ) {
                        manifestFileExists = true;
                        statusMsg = msg.data.status_msg;
                        mediaProgress = m.team_project_import_media_progress_completed();                       

                        player.src = videoOutputPath;
                        closeModal();
                    } else if (
                        msg.data.status === "done" &&
                        msg.data.result === "error"
                    ) {
                        manifestFileExists = true;
                        toast.push(`${msg.data.error}`, {
                            classes: ["toast-danger"],
                        });

                        closeModal();
                    }
                };

                break;
            case "Cloud Storage":
                /* Cloud Storage*/
                if (projectState.media.type === "video/quicktime") {
                    mediaType = "video/mp4";
                } else if (projectState.media.type === "video/x-matroska") {
                    mediaType = "video/mkv";
                } else {
                    mediaType = projectState.media.type;
                }

                //Get file size of url
                let fileSize = await getFileSize(projectState.media.path);
                if (fileSize) {
                    const sizeInBytes = parseInt(fileSize);
                    const sizeInKilobytes = sizeInBytes / 1024;
                    const sizeInMegabytes = sizeInKilobytes / 1024;
                    if (sizeInMegabytes < 512) {
                        projectState.media.useFallback = false;
                    }
                }

                player.src = { src: projectState.media.path, type: mediaType };

                /* Update Flags */
                manifestFileExists = true;
                audioExtractionComplete = true;

                break;
            default:
                /* Local Storage */
                if (!checkFileExistsSync(projectState.media.localPath)) {
                    toast.push(
                        m.team_project_import_media_not_found(),
                        { classes: ["toast-danger"] },
                    );
                    showModal("mediaImport");
                    return;
                }
                audioOutputPath = os.tmpdir() + path.sep + uid + ".json";
                audioWaveformPath = replaceFilename(
                    window.ffmpegPath,
                    environment.windows ? "audiowaveform.exe" : "audiowaveform",
                );

                manifestFileExists = true;
                mediaType =
                    !projectState.media.type ||
                    projectState.media.type === "video/quicktime"
                        ? "video/mp4"
                        : projectState.media.type;
                
                player.src = {
                    src: projectState.media.localPath,
                    type: mediaType,
                };
                ffmpegRes = await getFileMetadata(
                    projectState.media.localPath,
                    window.ffmpegPath
                );
                projectState.media.info = {
                    incode: getMediaIncode(ffmpegRes),
                    frameRate: getMediaFrameRate(ffmpegRes),
                    duration: getMediaDuration(ffmpegRes),
                };

                audioExtractionWorker.postMessage({
                    inputPath: projectState.media.localPath,
                    outputPath: audioOutputPath,
                    ffmpegPath: window.ffmpegPath,
                    duration: projectState.media.info.duration,
                });

                audioExtractionWorker.onmessage = (msg) => {
                    // console.log(msg);
                    if (msg.data.status === "in_progress") {
                        //statusMsg = msg.data.result;
                    } else if (msg.data.error){
                        projectState.media.peaksData = [[0],[0]];
                        audioExtractionComplete = true;
                        closeModal();
                    } else {
                        projectState.media.peaksPath = msg.data.error
                            ? ""
                            : audioOutputPath;
                        projectState.media.useFallback = false;

                        toast.push(
                            `${msg.data.error ? msg.data.error : m.team_project_import_media_import_complete()}`,
                            {
                                classes: [
                                    `toast-${msg.data.error ? "danger" : "success"}`,
                                ],
                            },
                        );

                        audioExtractionComplete = true;
                        closeModal();
                    }
                };
        }

        closeModal();
    } catch (err) {
        toast.push(m.team_project_import_media_import_failed(), {
            classes: ["toast-danger"],
        });

        showModal("mediaImport");
    }
}

function closeModal() {
    console.log(
        "Close Modal Called",
        audioExtractionComplete,
        manifestFileExists,
    );
    if (audioExtractionComplete && manifestFileExists) {
        statusMsg = m.team_project_import_status_project_complete();

        setTimeout(() => {
            uiState.timeline = true;
            hideModal();
        }, 2500);
    }
}

async function getFileSize() {
    try {
        const response = await fetch(projectState.media.path, {
            method: "HEAD",
        });
        const fileSize = response.headers.get("content-length");
        return fileSize;
    } catch (err) {
        return false;
    }
}
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'teamProjectImport'
        ? 'show d-block'
        : ''}"
    role="dialog"
    aria-labelledby="teamProjectImportTitle"
    aria-modal="true"
    tabindex="-1"
    id="TeamProjectImport">
    <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="teamProjectImportTitle">
                    {m.team_project_import_title()}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label={m.close()}
                    onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="mb-3">
                        <label class="form-label" for="shareCodeInput"
                            >{m.team_project_import_share_code_label()}</label>
                        <input
                            type="text"
                            class="form-control"
                            id="shareCodeInput"
                            bind:value={shareCode}
                            aria-describedby="shareCodeHelp" />
                        <small id="shareCodeHelp" class="form-text text-muted"
                            >{m.team_project_import_share_code_example()}</small>
                    </div>
                    {#if syncing}
                        <div class="loading-status-container text-center my-4" aria-live="polite" role="status">
                            <div class="loader-container d-flex justify-content-center mb-3">
                                <BarLoader
                                    size="300"
                                    color="#1eb4b2"
                                    unit="px"
                                    duration="3s"></BarLoader>
                            </div>
                            <p class="status-message fw-bold text-secondary mb-0">{statusMsg}</p>
                        </div>
                    {/if}
                    <button
                        type="button"
                        class="btn btn-primary float-end"
                        id="importProjectBtn"
                        onclick={importProject}
                        disabled={!shareCode || syncing}
                        aria-label={m.team_project_import_start_aria_label()}
                        >{m.team_project_import_button()}</button>
                </form>
            </div>
        </div>
    </div>
</div>
